var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "number-field",
    _vm._b(
      {
        attrs: {
          value: _vm.valueModel,
          "mask-type": _vm.maskType,
          "show-required-indicator": _vm.showRequiredIndicator,
        },
        on: {
          "update:value": function ($event) {
            _vm.valueModel = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "label",
              fn: function () {
                return [_vm._t("label")]
              },
              proxy: true,
            },
            {
              key: "prepend-input",
              fn: function () {
                return [_vm._t("prepend-input")]
              },
              proxy: true,
            },
            {
              key: "append-input",
              fn: function () {
                return [_vm._t("append-input"), _vm._v("\n    %\n  ")]
              },
              proxy: true,
            },
            {
              key: "before-input",
              fn: function () {
                return [_vm._t("before-input")]
              },
              proxy: true,
            },
            {
              key: "after-input",
              fn: function () {
                return [_vm._t("after-input")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "number-field",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }